var _defs, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M23.77 22.639a1 1 0 0 1-1.086.31l-5.652-1.884-4.66 1.864a.994.994 0 0 1-.743 0l-4.66-1.864-5.652 1.884a1.002 1.002 0 0 1-1.191-1.434l5-9.001a1.001 1.001 0 0 1 1.748.972l-3.75 6.753 3.56-1.187a.982.982 0 0 1 .688.02L12 20.922l4.629-1.85a.982.982 0 0 1 .688-.02l3.56 1.187-3.751-6.753a1 1 0 0 1 1.748-.972l5 9c.2.36.16.808-.104 1.125M12.71 6.709c-.19.18-.45.29-.71.29-.26 0-.52-.11-.71-.29A1.048 1.048 0 0 1 11 6c0-.26.11-.52.29-.71.37-.37 1.04-.37 1.42 0 .18.19.29.45.29.71 0 .26-.11.52-.29.71M12 3c1.655 0 3 1.347 3 3 0 3.203-1.83 6.487-2.943 8.19C10.937 12.282 9 8.607 9 5.999c0-1.653 1.346-3 3-3m-.043 14H12c.303 0 .59-.136.782-.374C12.954 16.41 17 11.29 17 6c0-2.757-2.243-5-5-5-2.756 0-5 2.243-5 5 0 4.254 3.999 10.3 4.168 10.555.177.266.47.43.789.444"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "#14BAD8",
    fillRule: "evenodd",
    transform: "translate(0 -1)",
    xlinkHref: "#a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueMap);
export default __webpack_public_path__ + "static/media/blue-map.728a8755412e9075fed304ea87962ade.svg";
export { ForwardRef as ReactComponent };